module.exports = __webpack_public_path__ + "assets/img/list_titleImg (4).c28bf063.png";